import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services/auth';
import { hasAdminAccess } from '@core/utils/admin-access.util';

export const loggedInGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isLoggedIn()) {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        const userData = user.user || user;
        const isStaff = hasAdminAccess(userData);
        const hasOrg = !!(userData.current_organization || user.current_organization || (user.organizations && user.organizations.length > 0));

        if (isStaff || hasOrg) {
          router.navigate(['/dashboard']);
          return false;
        }
      } catch (e) {
        // If user data is invalid, we might want to allow them to re-login
      }
    }
  }
  return true;
};
